import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, Toast, ToastContainer, Image, ToggleButton } from "react-bootstrap";
import {
  MdGridView,
  MdLocationOn,
  MdOutlineFormatListBulleted,
  MdOutlineEmail,
  MdOutlineCancel,
  MdOutlineSearch,
} from "react-icons/md";

import { RiCheckboxMultipleBlankLine, RiCheckboxMultipleLine, RiStarLine } from "react-icons/ri";

import { GrOrganization, GrAggregate } from "react-icons/gr";
import { apiGetLocalisations } from "../../../api/ApiLocalisation";
import { apiGetMarques } from "../../../api/ApiMarque";
import { useSelector } from "react-redux";
import MapGoogle from "../../../components/public/localisation/MapGoogle";
import { Link, useLocation } from "react-router-dom";
import ComponentToaster from "../../layout/ComponentToaster";
function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const BlocFiltresPersonnes = (props) => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  const { personnes, setFilterPersonnes, infoView, setInfoView, filterPersonnes } = props;

  const [countryFilter, setCountryFilter] = useState([]);
  const [marqueFilter, setMarqueFilter] = useState([]);
  const [mbtiFilter, setMbtiFilter] = useState(false);

  const [showCarte, setShowCarte] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showMarque, setShowMarque] = useState(false);
  const [showMbti, setShowMbti] = useState(false);

  const [query, setQuery] = useState("");
  const [countrySelected, setCountrySelected] = useState("");
  const [marqueSelected, setMarqueSelected] = useState([]);
  const [showMarquePrincipale, setShowMarquePrincipale] = useState(false);
  const [mbtiSelected, setMbtiSelected] = useState("");

  const [showToast, setShowToast] = useState(false);

  const [filtresAllumes, setFiltresAllumes] = useState([]);

  const profilsDisponibles = [
    {
      categorie: t("public.componentPersonne.profilMbtiCategorieAnalystes"),
      lettres: ["INTJ", "INTP", "ENTJ", "ENTP"],
    },
    {
      categorie: t("public.componentPersonne.profilMbtiCategorieDiplomates"),
      lettres: ["INFJ", "INFP", "ENFJ", "ENFP"],
    },
    {
      categorie: t("public.componentPersonne.profilMbtiCategorieSentinelles"),
      lettres: ["ISTJ", "ISFJ", "ESTJ", "ESFJ"],
    },
    {
      categorie: t("public.componentPersonne.profilMbtiCategorieExplorateurs"),
      lettres: ["ISTP", "ISFP", "ESTP", "ESFP"],
    },
  ];

  let queryParams = useQuery();

  const filterPersonnesByQuery = (pers, query) => {
    const searchString = query.toUpperCase();
    const regex = new RegExp(searchString);
    return pers.filter((pers) => {
      const persPrenom = pers.prenom.toUpperCase();
      const persNom = pers.nom.toUpperCase();
      /* si on trouve la recherche au debut du prenom ou au debut du nom  */
      if (persPrenom.search(regex) === 0 || persNom.search(regex) === 0) {
        return true;
      }
      return false;
    });
  };

  const filterPersonnesByLocalisation = (pers, localisation) => {
    return pers.filter((pers) => {
      const persCountry = pers.localisations;
      return persCountry.some((item) => item._id === localisation);
    });
  };

  const filterPersonnesByMarque = (personnes, marque) => {
    let newPersonnes = [];
    personnes.map((personne, index) => {
      if (personne.marque) {
        if (marque.filter((item) => item._id === personne.marque._id).length) {
          newPersonnes.push(personne);
        }
      } else {
        // si la personne n'a pas de marque affectée et qu'il n'y a pas de filtres de recherche particulier sur les marques alors on mpontre aussi ceux qui ont marque === null
        if (marque.length === marqueFilter.length) newPersonnes.push(personne);
      }
      return false;
    });
    return newPersonnes;
  };

  const filterPersonnesByMbti = (personnes, profilDemande, choixRetour = "tableauPersonnes") => {
    let newPersonnes = [];
    personnes.map((personne, index) => {
      if (personne.lettresMbti?.length) {
        let profilPersonne = "";
        profilPersonne += personne.lettresMbti[0] > 50 ? "I" : "E";
        profilPersonne += personne.lettresMbti[1] > 50 ? "N" : "S";
        profilPersonne += personne.lettresMbti[2] > 50 ? "F" : "T";
        profilPersonne += personne.lettresMbti[3] > 50 ? "P" : "J";
        if (profilPersonne === profilDemande) newPersonnes.push(personne);
      }
    });
    if (choixRetour === "tableauPersonnes") return newPersonnes;
    if (choixRetour === "countPersonnes" && newPersonnes.length)
      return " (" + newPersonnes.length + ")";
  };

  const recupLocalisations = async () => {
    const res = await apiGetLocalisations(ReduxInstance._id);
    if (res.data) {
      setCountryFilter(res.data);
    }
  };

  const recupMarques = async () => {
    const res = await apiGetMarques(ReduxInstance._id);
    if (res.data) {
      setMarqueFilter(res.data);
      setMarqueSelected(res.data);
    }
  };

  const recupProfilsMbti = () => {
    let aumoinsunprofil = personnes.filter((item) => item.lettresMbti?.length > 0);
    aumoinsunprofil.length ? setMbtiFilter(true) : setMbtiFilter(false);
  };

  const InfosTiersLieu = () => {
    const localisation = countryFilter.filter((item) => item._id === countrySelected);

    if (localisation.length === 1) {
      return (
        <div className="ms-2">
          <div>
            <h1>{localisation[0].nom}</h1>
          </div>
          <div>{localisation[0].adresse}</div>
          <div> {localisation[0].pays}</div>
          <div className="mt-5">
            <Link to={"/espaces?localisation=" + localisation[0]._id}>
              {t("public.componentPersonne.details")}
            </Link>
          </div>
        </div>
      );
    }

    return <></>;
  };

  const genereMailingList = () => {
    let mailingList = "";
    filterPersonnes.forEach((element) => {
      if (element.email) {
        mailingList += element.email + ";";
      }
    });
    navigator.clipboard.writeText(mailingList);
    setShowToast(true);
    //return "mailto:" + mailingList;
  };

  const cancelFiltres = () => {
    setQuery("");
    setShowCarte(false);
    setShowMarque(false);
    setShowSearch(false);
    setShowMbti(false);
    setCountrySelected("");
    setMbtiSelected("");
    setMarqueSelected(marqueFilter);
  };

  const toggleMarque = (marque) => {
    if (marqueSelected.filter((item) => item._id === marque.value).length) {
      setMarqueSelected(marqueSelected.filter((item) => item._id !== marque.value));
    } else {
      let newmarquesSelected = [...marqueSelected];
      let rajoutMarque = marqueFilter.filter((item) => item._id === marque.value);
      newmarquesSelected.push(rajoutMarque[0]);
      setMarqueSelected(newmarquesSelected);
    }
  };

  const toggleBoutonsFiltresPersonnes = () => {
    let filtresAllumesPreparation = [];

    /* localisation selectionnee */
    if (countrySelected !== "") filtresAllumesPreparation.push("localisation");

    /* au moins une case usages n'a pas été cochée */
    if (marqueSelected.length !== marqueFilter.length) filtresAllumesPreparation.push("marques");

    /* MBTI selectionnee */
    if (mbtiSelected !== "") filtresAllumesPreparation.push("mbti");

    setFiltresAllumes(filtresAllumesPreparation);
  };

  useEffect(() => {
    recupLocalisations();
    recupMarques();
    recupProfilsMbti();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    /* on recopie le tableau d'origine */
    let personnesCopy = personnes;

    /* on applique le filtre query (recherche) si renseigné */
    if (query) {
      personnesCopy = filterPersonnesByQuery(personnesCopy, query);
    }

    /* on applique le filtre country si renseigné */
    if (countrySelected) {
      personnesCopy = filterPersonnesByLocalisation(personnesCopy, countrySelected);
    }

    /* on applique le filtre marque si renseigné */
    if (marqueSelected && marqueFilter.length > 0) {
      personnesCopy = filterPersonnesByMarque(personnesCopy, marqueSelected);
    }

    /* on applique le filtre mbti si renseigné */
    if (mbtiSelected) {
      personnesCopy = filterPersonnesByMbti(personnesCopy, mbtiSelected);
    }

    /* permet de mettre en jaune les filtres actifs (ceux ou l'on a dcoche des cases par exemple) */
    toggleBoutonsFiltresPersonnes();

    setFilterPersonnes(personnesCopy);
  }, [personnes, query, countrySelected, marqueSelected, mbtiSelected]); // eslint-disable-line react-hooks/exhaustive-deps

  const filtreMarquePrincipale = () => {
    let marquePinned = [];
    marquePinned = marqueFilter.filter((item) => item.pinned);
    if (marquePinned.length >= 1) {
      setMarqueSelected(marquePinned);
      setShowMarquePrincipale(true);
    }
  };

  useEffect(() => {
    if (queryParams.get("name")) {
      setQuery(queryParams.get("name"));
      setShowSearch(true);
    }
  }, [queryParams]);

  useEffect(() => {
    filtreMarquePrincipale();
  }, [marqueFilter]);

  return (
    <>
      <div className="d-flex mb-3 justify-content-left contentPersonneFilterSortSearch flex-wrap">
        <div className="d-flex  p-2 m-2 border">
          {/* <div className="m-1">Affichage:</div> */}
          <div className="d-flex align-items-center">
            <ToggleButton
              size="sm"
              className="mb-1"
              id="toggle-check-info"
              type="checkbox"
              variant=""
              checked={infoView}
              value="1"
              onChange={(e) => setInfoView(e.currentTarget.checked)}
            >
              {!infoView ? <MdGridView size="2em" /> : <MdOutlineFormatListBulleted size="2em" />}
            </ToggleButton>
          </div>
        </div>
        {countryFilter.length > 1 && (
          <div
            className={
              filtresAllumes.includes("localisation")
                ? "d-flex blocFilter p-2 m-2  border align-items-center filtreActif"
                : "d-flex blocFilter p-2 m-2  border align-items-center filtreNonActif"
            }
          >
            <MdLocationOn size="2em" onClick={(e) => setShowCarte(!showCarte)} role="button" />
          </div>
        )}
        {marqueFilter.length > 1 && (
          <div
            className={
              filtresAllumes.includes("marques")
                ? "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreActif"
                : "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreNonActif"
            }
          >
            <GrOrganization
              size="1.5em"
              onClick={(e) => setShowMarque(!showMarque)}
              role="button"
            />
          </div>
        )}
        {mbtiFilter && (
          <div
            className={
              filtresAllumes.includes("mbti")
                ? "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreActif"
                : "blocFilter blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center filtreNonActif"
            }
          >
            <GrAggregate size="1.5em" onClick={(e) => setShowMbti(!showMbti)} role="button" />
          </div>
        )}
        <div className="blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center">
          <MdOutlineSearch size="2em" onClick={(e) => setShowSearch(true)} role="button" />
          {showSearch && (
            <Form.Control
              type="text"
              name="nom"
              placeholder={t("commun.form.placeholder.rechercher")}
              value={query}
              className="border-0 "
              onChange={(e) => setQuery(e.target.value)}
            />
          )}
        </div>
        <div className="blocSearch p-2 m-2 border d-flex flex-nowrap align-items-center">
          {/* <a href={genereMailingList()}>
            <MdOutlineEmail size="2em" role="button" />
          </a> */}
          <MdOutlineEmail
            size="2em"
            role="button"
            onClick={() => {
              genereMailingList();
            }}
          />
          <ComponentToaster
            message={t("commun.mailing")}
            showToast={showToast}
            setShowToast={setShowToast}
            delay="5000"
          />
        </div>
        {(query.length > 0 ||
          countrySelected ||
          mbtiSelected ||
          marqueSelected.length !== marqueFilter.length) && (
          <div className="d-flex m-2 align-items-center  ">
            <MdOutlineCancel
              size="1.5em"
              role="button"
              onClick={() => cancelFiltres("")}
              className="ms-2 text-danger"
            />
          </div>
        )}
      </div>

      {showCarte && (
        <div className="d-flex  flex-wrap border-bottom pb-3 mb-3">
          <MapGoogle coordonnees={countryFilter} setCountrySelected={setCountrySelected} />
          <InfosTiersLieu />
        </div>
      )}
      {showMarque && (
        <div className="d-flex flex-nowrap border-bottom pb-3 mb-3 containerFiltresSecondeNiveau">
          {showMarquePrincipale && (
            <span
              onClick={(e) => filtreMarquePrincipale()}
              className="m-1 p-1 border align-items-center d-flex"
            >
              <RiStarLine size="1.5em" role="button" className="text-danger" />
            </span>
          )}
          <span
            onClick={(e) => setMarqueSelected([])}
            className="m-1 p-1 border align-items-center d-flex"
          >
            <RiCheckboxMultipleBlankLine size="1.5em" role="button" className="text-danger" />
          </span>
          <span
            onClick={(e) => setMarqueSelected(marqueFilter)}
            className="m-1 p-1 border align-items-center d-flex"
          >
            <RiCheckboxMultipleLine size="1.5em" role="button" className=" text-danger" />
          </span>
          {marqueFilter.map((marque) => (
            <div
              key={marque._id}
              className="m-1 p-1 border align-items-center justify-content-center d-flex flex-wrap"
            >
              {marque.marquePic && (
                <label for={"marque_" + marque._id}>
                  <Image
                    src={process.env.REACT_APP_URL_EXPRESS + "images/marque/" + marque.marquePic}
                    width={100}
                    className="me-1"
                  />
                </label>
              )}
              <Form.Check
                id={"marque_" + marque._id}
                name={"marque_" + marque._id}
                type="checkbox"
                label={marque.nom}
                value={marque._id}
                checked={
                  marqueSelected.filter((item) => item._id === marque._id).length ? "checked" : ""
                }
                onChange={(e) => toggleMarque(e.target)}
              />
            </div>
          ))}
        </div>
      )}

      {showMbti && (
        <div className="d-flex flex-nowrap border-bottom pb-3 mb-3 containerFiltresSecondeNiveau">
          {profilsDisponibles.map((profil, indexCategorie) => (
            <div
              key={indexCategorie}
              className="d-flex flex-column align-items-center border p-2 m-1"
            >
              <div className="fw-bold">{profil.categorie}</div>
              <div className="d-flex flex-nowrap">
                {profil.lettres.map((lettre, indexLettres) => (
                  <div
                    onClick={(e) => setMbtiSelected(lettre)}
                    key={indexLettres}
                    className={
                      mbtiSelected == lettre ? "border p-1 m-1 filtreActif" : "border p-1 m-1"
                    }
                  >
                    {lettre}
                    <span className="fw-bold">
                      {filterPersonnesByMbti(personnes, lettre, "countPersonnes")}
                    </span>{" "}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default BlocFiltresPersonnes;
